<template>
  <div id="IntegratedModelList" class="page">
    <file-page-title />
    <div class="search-line">
      <div>
        <span class="ft-tip-grey">说明：交付模型不随文件版本变动更新。</span>
      </div>
      <div class="btn-right">
        <span>共 {{ dataTotal }} 个内容</span>
        <el-button
            type="text"
            icon="el-icon-refresh-right"
            title="刷新"
            class="refresh-btn"
            @click.stop="handleRefresh"
        />
      </div>
    </div>
    <gjw-dimensions @height-changed="onBoxHeightChanged">
      <div class="content-container">
        <div class="fix-flex-table">
          <gjw-table
              ref="listTable"
              v-loading="tableLoading"
              :columns="tableColumns"
              :list-data="tableData"
              :has-page="false"
              :max-height="tableHeight"
          >
            <template #nameSlot="{ row, index }">
              <edit-input
                  v-if="modifyIndex === index && modifyCol === 'name'"
                  @click.stop.native
                  ref="editName"
                  :maxlength="30"
                  :init-value="tempRow.name"
                  @edit-confirm="(value)=>modifyName(row, value)"
                  @edit-cancel="resetModify"
              />
              <span v-else class="table-name">
                  <img class="file-img" src="../../../assets/file/model.png" style="margin-right: 6px;" alt="" />
                  <span :class="{'name-click':row.bimfaceTranslateStatus === 'SUCCESS'}" @click.stop="toView(row)">{{ row.name }}</span>
                <el-tooltip v-show="row.bimfaceTranslateStatus === 'PROCESSING'" content="转换中" placement="top">
                    <i class="el-icon-loading table-cell-icon" />
                  </el-tooltip>
                <div v-show="row.bimfaceTranslateStatus === 'FAILED'" class="table-cell-icon" style="top: 0;">
                  <el-tooltip content="转换失败，请重新转换" placement="top">
                    <i class="iconfont icon-shibai icon-red" />
                </el-tooltip>
                <el-tooltip content="重新转换" placement="top">
                    <i class="iconfont icon-zhuanhuan icon-blue" @click="toTranslate(row)" />
                </el-tooltip>
                </div>
                </span>
            </template>
            <template #fileSlot="{ row }">
              <div>
                <span>{{row.fileCount || 0}}</span>
                <el-button type="text" class="mg-lt-md" @click.stop="toViewDetail(row)">详情<i class="el-icon-arrow-right"/></el-button>
              </div>
            </template>
            <template #offlineSlot="{ row, index }">
              <div>
                <div @click.stop>
                  <el-popconfirm
                      :ref="`popconfirm${index}`"
                      placement="top"
                      width="200"
                      icon="el-icon-warning"
                      title="是否确定生成？"
                      @confirm="toCreateOffline(row, index)"
                      @cancel="closePopConfirm"
                  >
                    <el-button
                        v-if="row.bimfaceTranslateStatus !== 'SUCCESS' || !row.offlinePackageStatus || row.offlinePackageStatus === 'PREPARE'"
                        class="offline-button"
                        slot="reference"
                        plain
                        :disabled="row.bimfaceTranslateStatus !== 'SUCCESS'"
                        @click.stop="closePopConfirm"
                    >生成</el-button>
                  </el-popconfirm>
                </div>
                <el-button v-if="row.bimfaceTranslateStatus === 'SUCCESS' && ['PROCESSING', 'QUEUING'].includes(row.offlinePackageStatus)" class="offline-button" plain disabled>生成中...</el-button>
                <div v-if="row.offlinePackageStatus === 'SUCCESS'" class="offline-button" plain @click.stop="toDownloadOffline(row)">
                  <img src="@/assets/img/offline-package.png" width="16" style="margin-right: 2px;" />
                  <span>下载离线包</span>
                </div>
                <div v-if="row.offlinePackageStatus === 'FAILED'" class="offline-button ft-theme" plain @click.stop="toCreateOffline(row)">
                  <i class="iconfont icon-tongyong_Warning-1 ft-yellow" />
                  <span>重试</span>
                </div>
              </div>
            </template>
            <template #operateSlot="{ row , index }">
              <div @click.stop @dbclick.stop>
                <el-tooltip v-if="row.bimfaceTranslateStatus !== 'SUCCESS'" content="转换成功后可以操作" placement="top">
                  <el-button type="text" :disabled="true">分享</el-button>
                </el-tooltip>
                <el-button v-else type="text" @click.stop="toShare(row)">分享</el-button>
                <el-dropdown>
                    <span class="el-dropdown-link">
                      <i class="el-icon-more ft-theme"></i>
                    </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :disabled="row.bimfaceTranslateStatus !== 'SUCCESS'" @click.stop.native="renameModel(row, index, 'name')"><span>重命名</span></el-dropdown-item>
                    <el-dropdown-item class="delete-button" @click.stop.native="deleteModel(row, index)"><span>删除</span></el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>
          </gjw-table>
        </div>
      </div>
    </gjw-dimensions>
    <!-- 分享整合模型 -->
    <model-share-dialog ref="ModelShareDialog" share-type="INTEGRATED_MODEL" @share-link-opened='shareTrack' />
    <!-- 方案详情 -->
    <integrated-model-detail ref="integratedModelDetail" :space-id="spaceId" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import FilePageTitle from '../components/FilePageTitle.vue'
import EditInput from '@/components/business/EditInput.vue'
import { RegSymbol } from '@/core/RegExp'
import { integratedErrorCodeMap } from '../errorCodeMap'
import GjwDimensions from '@/components/lib/GjwDimensions.vue'
import openUrlMixin from '@/mixins/openUrlMixin'
import ModelShareDialog from '@/views/file/components/ModelShareDialog.vue'
import IntegratedModelDetail from '@/views/file/components/IntegratedModelDetail.vue'
import pollingMixin from '@/mixins/pollingMixin'

export default {
  name: 'IntegratedModelList',
  components: { IntegratedModelDetail, ModelShareDialog, GjwDimensions, FilePageTitle, EditInput },
  mixins: [openUrlMixin, pollingMixin],
  data() {
    return {
      spaceId: this.$route.params.spaceId,
      dataTotal: 0,
      tableHeight: 0,
      tableLoading: false,
      tableData: [],
      modifyIndex: -1, // 当前要修改的行序
      modifyCol: '', // 当前要修改的col
      tempRow: {}, // 备份要修改的row
    }
  },
  computed: {
    ...mapGetters({
      clientType: 'platform',
    }),
    tableColumns() {
      return [
        {
          type: 'slot',
          slotName: 'nameSlot',
          label: '名称',
          prop: 'name',
          minWidth: '200px',
        },
        {
          type: 'slot',
          slotName: 'fileSlot',
          label: '合模文件',
          showOverflowTooltip: false,
          prop: 'fileCount',
          minWidth: '80px',
        },
        {
          label: '创建人',
          prop: 'creatorName',
          minWidth: '100px',
        },
        {
          label: '创建时间',
          prop: 'createTime',
          width: '160px',
          formatter: (row, col, cell) => {
            return this.$fmtTime(cell, 'YYYY-MM-DD HH:mm:ss')
          },
        },
        {
          type: 'slot',
          slotName: 'offlineSlot',
          label: '离线包',
          showOverflowTooltip: false,
          prop: 'offlinePackageStatus',
          minWidth: '140px',
        },
        {
          type: 'slot',
          slotName: 'operateSlot',
          label: '操作',
          width: '120px'
        },
      ]
    }
  },
  created() {
    this.getList()
    this.startPolling(this.polling)
  },
  methods: {
    onBoxHeightChanged({ newValue }) {
      this.tableHeight = newValue
    },
    async handleRefresh() {
      await this.getList()
      this.$message.success('数据已刷新')
    },
    async polling() {
      this.$api.file.integratedModelList(this.spaceId).then((data) => {
        if (data) {
          this.tableData = data.list || []
          this.dataTotal = data.totalCount || 0
        }
      })
    },
    async getList() {
      // 更新数据时，取消编辑状态
      this.resetModify()
      this.tableLoading = true
      this.$api.file.integratedModelList(this.spaceId).then((data) => {
        if (data) {
          this.tableData = data.list || []
          this.dataTotal = data.totalCount || 0
        }
      }).catch((err) => {
        this.$matchError(err.code, {}, '获取交付模型列表失败')
      }).finally(() => {
        this.tableLoading = false
      })
    },
    // 修改之后重置
    resetModify() {
      this.modifyCol = ''
      this.modifyIndex = -1
      this.tempRow = {}
      this.startPolling(this.polling)
    },
    // 修改名称
    modifyName(row, value) {
      if (row.name === value) {
        this.resetModify()
        return
      }
      if (!value && value !== 0) {
        this.$message.error('请输入名称')
        return
      }
      if (RegSymbol.test(value)) {
        this.$message.error('名称中有禁止的特殊符号')
        return
      }
      this.$api.file.renameIntegratedModel(this.spaceId, row.id, { name: value }).then((res) => {
        if (res === true) {
          this.$message.success(`修改成功`)
          this.resetModify()
          this.getList()
          this.$tracks({
            event: 'renameIntegratedModel',
            params: { g_c_space_id: this.spaceId, g_c_integrated_model_id: row.id }
          })
        }
      }).catch((err) => {
        this.$matchError(err.code, integratedErrorCodeMap, '修改失败')
      })
    },
    // 查看模型
    toView(row) {
      if (row.bimfaceTranslateStatus !== 'SUCCESS') { return }
      this.$tracks({
        event: '3DViewIntegratedModel',
        params: {
          g_c_space_id: this.spaceId,
          g_c_integrated_model_id: row.id,
        }
      })
      const view = this.$router.resolve({
        name: 'IntegratedModelView',
        params: { spaceId: this.spaceId },
        query: {
          id: row.id,
          title: row.name
        }
      })
      const viewUrl = `${process.env.VUE_APP_PROJECT_HOST}${view.href}`
      this.openUrl(viewUrl, true, '_blank')
    },
    toTranslate(row) {
      this.$api.file.translateIntegratedModel(this.spaceId, row.id).then(() => {
        row.bimfaceTranslateStatus = 'PROCESSING'
      }).catch((err) => {
        this.$matchError(err.code, integratedErrorCodeMap, '重新转换失败')
      })
    },
    // 查看方案详情
    toViewDetail(row) {
      this.$refs.integratedModelDetail?.openDrawer(row)
      this.$tracks({
        event: 'viewIntegratedModelDetail',
        params: {
          g_c_space_id: this.spaceId,
          g_c_integrated_model_id: row.id,
        }
      })
    },
    // 去分享
    toShare(row) {
      this.$refs.ModelShareDialog?.openDialog(row)
    },
    shareTrack(shareModelFileInfo) {
      this.$tracks({
        event: 'shareIntegratedModel',
        params: {
          g_c_space_id: this.spaceId,
          g_c_integrated_model_id: shareModelFileInfo.id,
        }
      })
    },
    renameModel(row, index, colName) {
      this.stopPolling()
      this.modifyCol = colName
      this.modifyIndex = index
      this.tempRow = { ...row }
      this.$nextTick(() => {
        switch (colName) {
          case 'name':
            this.$refs.editName.toFocus()
            break
        }
      })
    },
    deleteModel(row, index) {
      const tooltipText = `删除后<span style="color: red;">无法恢复</span>，分享链接将失效，是否确定删除${row.name}？`
      this.$confirm(tooltipText, {
        type: 'warning',
        dangerouslyUseHTMLString: true,
        confirmButtonClass: 'user-confirm',
        confirmButtonText: '确定删除',
      }).then(() => {
        this.$api.file.deleteIntegratedModel(this.spaceId, row.id).then(() => {
          this.$message.success(`删除成功`)
          this.$tracks({
            event: 'deleteIntegratedModel',
            params: { g_c_space_id: this.spaceId, g_c_integrated_model_id: row.id }
          })
          // 将数据在表格中移除
          this.tableData.splice(index, 1)
        }).catch((err) => {
          this.$matchError(err.code, integratedErrorCodeMap, '删除失败')
        })
      }).catch()
    },
    // 移除焦点，避免 aria-hidden 警告
    removeFocus() {
      const activeElement = document.activeElement
      if (activeElement?.blur) {
        activeElement.blur()
      }
    },
    closePopConfirm() {
      this.removeFocus()
      // 为了解决出现多个确认气泡的情况
      this.$nextTick(() => {
        document.getElementById('IntegratedModelList').click()
      })
    },
    toCreateOffline(row) {
      this.removeFocus()
      this.$api.file.createOfflinePackage(this.spaceId, row.id).then(() => {
        this.getList()
        this.$tracks({
          event: 'exportOfflinePackage',
          params: { g_c_space_id: this.spaceId, g_c_file_id: row.id, g_c_file_type: 'INTEGRATED_MODEL' }
        })
      }).catch((err) => {
        this.$matchError(err.code, integratedErrorCodeMap, '生成失败')
      })
    },
    toDownloadOffline(row) {
      this.$api.file.getOfflinePackageUrl(this.spaceId, row.id).then((res) => {
        if (this.clientType === 'web') {
          this.$downloadFile(res)
        } else {
          this.$desktopClient.NavigateToBrowser(res)
        }
        this.$tracks({
          event: 'downloadOfflinePackage',
          params: {
            g_c_space_id: this.spaceId,
            g_c_file_id: row.id,
            g_c_file_type: 'INTEGRATED_MODEL'
          }
        })
      }).catch((err) => {
        this.$matchError(err.code, integratedErrorCodeMap, '获取下载地址失败')
      })
    },
  },
}
</script>

<style lang="less" scoped>
.search-line {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px;
}
.content-container{
  margin: 0 16px;
  display: flex;
  flex-direction: column;
  position: relative;
  height: calc(100% - 108px);
}
.file-img {
  width: 20px;
  height: 20px;
  vertical-align: middle;
}
.name-click{
  cursor: pointer;
  color: @theme-color;
}
.delete-button{
  color: red;
  &:hover{
    color: #fff;
    background: red;
  }
}
.table-cell-icon{
  font-size: 16px;
  .icon-blue{
    cursor: pointer;
    margin-left: 6px;
  }
}
.offline-button{
  width: 100%;
  max-width: 140px;
  height: 32px;
  border-radius: 2px;
  border: 1px solid #e6e6e6;
  font-weight: normal;
  line-height: 24px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  &:hover{
    color: @theme-color;
    border-color: @theme-color;
  }
  .iconfont{
    font-size: 14px;
    margin-right: 2px;
  }
}
.icon-red{
  color: @error-color;
}
.icon-blue{
  color: @theme-color;
}

</style>
